import { Injectable } from '@angular/core';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

@Injectable({ providedIn: 'root' })
export class DateFormatService {

  /**
   * Converts any recognized date string to DD-MMM-YYYY.
   * Handles: ISO datetime (2025-01-15T...), YYYY-MM-DD, DD-MM-YYYY.
   * Returns the input unchanged if no pattern matches.
   */
  format(value: string | null | undefined): string {
    if (!value) return '';
    const v = value.toString().trim();

    // Already DD-MMM-YYYY — return as-is
    if (/^\d{2}-[A-Za-z]{3}-\d{4}$/.test(v)) return v;

    // ISO datetime or YYYY-MM-DD
    const isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(v);
    if (isoMatch) {
      const [, y, m, d] = isoMatch;
      const mon = MONTHS[parseInt(m, 10) - 1] ?? m;
      return `${d.padStart(2, '0')}-${mon}-${y}`;
    }

    // DD-MM-YYYY
    const dmyMatch = /^(\d{2})-(\d{2})-(\d{4})$/.exec(v);
    if (dmyMatch) {
      const [, d, m, y] = dmyMatch;
      const mon = MONTHS[parseInt(m, 10) - 1] ?? m;
      return `${d}-${mon}-${y}`;
    }

    return v;
  }
}
